import ImageSourceDeviceModel from '../../models/IDaq/ImageSourceDeviceModel';
import BaseStore from '../BaseStore';
import {action} from "mobx/lib/mobx";

class ImageSourceDeviceStore extends BaseStore {
  constructor(transportLayer) {
    super(ImageSourceDeviceModel, transportLayer);
  }

  fetchBySource(id){
    this.isLoading = true;

    const handleFetchAllSuccess = fetchedItems => {
      fetchedItems.forEach(json => {
        this.updateItemFromServer(json);
      });
      this.isLoading = false;
      return fetchedItems;
    };

    return this
      ._fetchById(id)
      .then(action(handleFetchAllSuccess))
      .catch(action(err => {
        console.log('err', err);
        this.isLoading = false;
      }));
  }

  fetchStationAlbum(id) {
    return this.transportLayer.fetchAlbumsByStationID(id);
  }

}

export default ImageSourceDeviceStore;


// WEBPACK FOOTER //
// ./src/stores/IDaq/ImageSourceDeviceStore.js